import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastController, ModalController } from '@ionic/angular';
import { TournamentService } from '../../../gamer/services/tournament.service';
import { IPlayer, ITeam, LineUpService, TshirtStyle, TshirtType } from '../../services/lineup-service';
import { Router } from '@angular/router';

@Component({
  selector: 'create-team',
  templateUrl: 'create-team.html',
  styleUrls:['./create-team.scss']
})
export class CreateTeamComponent {
  activePlan: number = 0;
  formGroup: FormGroup;
  routerState:any;

  constructor(
    public viewCtrl: ModalController,
    private toastCtrl: ToastController,
    private translate: TranslateService,
    private router:Router,
    public ls: LineUpService,
    public gs: TournamentService
  ) { 
    const nav = this.router.getCurrentNavigation();
    this.routerState = nav?.extras?.state || {};

    this.formGroup = new FormGroup({
      name: new FormControl(this.team.name, [Validators.required, Validators.maxLength(50)])
    });
  }

  ionViewDidEnter() {
    this.activePlan = this.routerState['activePlan'] || this.activePlan;
    this.team = this.routerState['team'] || this.team;
    this.setDefaultColors();
  }

  setDefaultColors() {
    document.documentElement.style.setProperty('--tshirtcolor1', this.ls.field.color1);
    document.documentElement.style.setProperty('--tshirtcolor2', this.ls.field.color2);
  }

  onValueChange(key, value){
    this.ls.field[key] = value;
    this.ls.saveDisplayConfigs();
  }

  onColorSelect(color, index) {
    if (index > 0) {
      this.ls.field.color2 = color;
      document.documentElement.style.setProperty('--tshirtcolor2', color);
    } else {
      this.ls.field.color1 = color;
      document.documentElement.style.setProperty('--tshirtcolor1', color);
    }
  }

  onAddTeam() {
    if (!this.validation()) return;

    this.team.name = this.formGroup.value.name;
    this.gs.planList[this.activePlan].teams.push(this.team);
    this.gs.saveTou(this.gs.planList[this.activePlan]).then(plan => this.gs.planList[this.activePlan] = plan);
    this.gs.save();
    this.viewCtrl.dismiss();
  }

  onDeleteTeam(){
    if (this.gs.planList[this.activePlan]) {
      this.gs.planList[this.activePlan].teams = this.gs.planList[this.activePlan].teams.filter(t => t.id != this.team.id);
      this.gs.removeTeamById(this.team.id);
      this.gs.save();
    }
    this.viewCtrl.dismiss();
  }

  validation(): boolean {
    if (this.formGroup.invalid) {
      this.submitted = true;
      this.toastCtrl.create({
        message: this.translate.instant("FILL_IN_ALL_MESSAGE"),
        position: 'top',
        duration: 3000
      }).then(toast=>toast.present());
      return false;
    }
    return true;
  }

  public get style(): typeof TshirtStyle {
    return TshirtStyle;
  }

  submitted: boolean = false;

  styles = [
    this.translate.instant('ONE_COLOR'),
    this.translate.instant('HORIZONTAL_LINES'),
    this.translate.instant('VERTICAL_LINES')
  ];

  types = [
    this.translate.instant('bandedcollar'),
    this.translate.instant('henley'),
    this.translate.instant('hoodie'),
    this.translate.instant('longsleeves'),
    this.translate.instant('nosleeves'),
    this.translate.instant('polo'),
    this.translate.instant('shirt'),
    this.translate.instant('tshirt'),
    this.translate.instant('vneck')
]

  team: ITeam = {
    id: new Date().getTime(),
    name: "",
    players: [],
    results: 0,
    points: 0,
    ord:0
  };
}

